import 'jquery';
import { createApp } from 'vue'
import Vuex from 'vuex';
import store from './store/index'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import router from './router'
import util from '../static/plugin/util'
import  '../static/plugin/common'
import  '../static/plugin/static_param'
import '../static/plugin/common.css'
import '../static/plugin/iconfont/iconfont.css';

import locale from 'element-plus/lib/locale/lang/zh-cn'
import 'dayjs/locale/zh-cn'

import permission from '../static/plugin/permission'

import App from './App.vue'

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

let app = createApp(App);
app.directive('premission', {
  mounted(el, binding, vnode){
    permission.doPermission(el,binding,vnode,store);
  }
})
app.config.isCustomElement = tag => tag.startsWith('wx-')

router.app = app.use(VueViewer,{defaultOptions: {zIndex:9999}}).use(router).use(ElementPlus, { size:"small",zIndex: 3000,locale }).use(Vuex).use(store).use(util).mount('#app');
